
import { getSequenceItemListPayload } from "../Functions";

export function SaveSequence(this: any): any {
  return {
    type: this.type, //State, Category or Event
    categoryId: this.categoryId, //-1 when type is category, 1(SubCase) or 2(Case) when Event
    itemList: getSequenceItemListPayload(this.type, this?.sequenceList),
  };
}
